import { useMemo } from "react";
import {
  Paper,
  Typography,
  Box,
} from "@mui/material";

import WGRTable from "./caSTable";
import WGRTotals from "./caSTotals";

export default function WGRShopGroup({
  shop,
  rows,
}) {
  /*
   * Shop Total
   */
  const totals = useMemo(() => {
    return rows.reduce(
      (sum, row) => {

        const actualL = Number(row["ACTUAL ON COST LABOUR"] || 0);
        const distL = Number(row["DISTRIBUTED ON COST LABOUR"] || 0);
        const ou_L = actualL - distL;
        const actualS = Number(row["ACTUAL ON COST STORE"] || 0);
        const distS = Number(row["DISTRIBUTED ON COST STORE"] || 0);
        const ou_S = actualS - distS;


        return {
          actual_L: sum.actual_L + actualL,
          dist_L: sum.dist_L + distL,
          ou_LL: sum.ou_LL + ou_L,
          actual_S: sum.actual_S + actualS,
          dist_S: sum.dist_S + distS,
          ou_SS: sum.ou_SS + ou_S,

        };
      },
      {
        actual_L: 0,
        dist_L: 0,
        ou_LL: 0,
        actual_S: 0,
        dist_S: 0,
        ou_SS: 0,






      }
    );
  }, [rows]);

  return (
    <Paper
      elevation={2}
      sx={{
        overflow: "hidden",
        borderRadius: 2,
      }}
    >
      {/* Shop Header */}

      <Box
        sx={{
          bgcolor: "primary.main",
          color: "white",
          px: 2,
          py: 1,
          mt: 5,
        }}
      >
        <Typography
          variant="h6"
          fontWeight={700}

        >
          {shop}
        </Typography>
      </Box>

      {/* Detail Table */}

      <WGRTable rows={rows} />

      {/* Shop Total */}

      <WGRTotals
        shop={shop}
        totals={totals}
      />
    </Paper>
  );
}

